import Head from 'next/head';
import dynamic from 'next/dynamic';
import { useAuth } from '../../hooks/useAuth';

const MystereGame = dynamic(
  () => import('../../components/games/FrenchWordleSimple'),
  {
    loading: () => (
      <div className="min-h-screen flex items-center justify-center bg-theme-primary">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent mx-auto mb-4"></div>
          <p className="text-theme-secondary">Chargement du jeu...</p>
        </div>
      </div>
    ),
    ssr: false,
  }
);

const MySterePage = () => {
  const { user, isAuthenticated } = useAuth();

  return (
    <>
      <Head>
        <title>Mystère: Wordle Français | Fenkparet</title>
        <meta name="description" content="Jouez à Mystère, le Wordle français ! Devinez le mot de 5 lettres en 6 tentatives." />
        <meta name="keywords" content="mystere, wordle français, jeu de mots, puzzle, devinette, français" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        <meta property="og:title" content="Mystère — Wordle Français | Fenkparet" />
        <meta property="og:description" content="Devinez le mot de 5 lettres en 6 tentatives." />
        <meta property="og:type" content="game" />
        <meta property="og:url" content="https://fenkparet.com/jeux/mystere" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mystère — Wordle Français" />
        <meta name="twitter:description" content="Devinez le mot de 5 lettres en 6 tentatives." />

        <link rel="icon" href="/favicon.ico" />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Game',
              name: 'Mystère',
              description: 'Un jeu de devinette de mots français basé sur Wordle',
              url: 'https://fenkparet.com/jeux/mystere',
              gamePlatform: 'Web Browser',
              genre: 'Word Game',
              numberOfPlayers: '1',
              inLanguage: 'fr',
              publisher: { '@type': 'Organization', name: 'Fenkparet', url: 'https://fenkparet.com' },
            }),
          }}
        />
      </Head>

      <div className="min-h-screen bg-theme-primary">
        <div className="bg-theme-secondary/90 backdrop-blur-sm shadow-sm border-b border-theme py-2">
          <div className="max-w-lg mx-auto px-4 text-center">
            <p className="text-xs text-theme-secondary">
              {isAuthenticated
                ? `Connecté — statistiques sauvegardées`
                : `Connectez-vous pour sauvegarder vos statistiques`}
            </p>
          </div>
        </div>
        <MystereGame />
      </div>
    </>
  );
};

export default MySterePage;
